angular.module('wbDashboard').controller('LoginControllerAurea',
    ['$scope', 'Auth', 'Login', 'FPJS', 'Message', 'Session', '$timeout', '$window', '$uibModal', 'Track', 'bugsnagClient',
function ($scope, Auth, Login, FPJS, Message, Session, $timeout, $window, $uibModal, Track, bugsnagClient) {
    
    if (Auth.isLoggedIn() && $scope.$state.current.name !== "public.login.otp") {
        $scope.$state.go('base.overview');
    }

    $scope.hardReload = false;
    $scope.pageData = {
        sending: false,
        success: false,
        errorMsg: null,
        errorCount: 0,
        loginCount: Session.get('login-count') || 0,
    };
    $scope.forms = {};
    $scope.credentials = {};

    var logoutMessage = Session.get('logout-message');
    if (logoutMessage) {
        Session.remove('logout-message');
        Message.set({text: logoutMessage.message, type: logoutMessage.type});
    }

    $scope.submit = function () {
        Message.clear();
        $scope.pageData.sending = true;

        var fp = {};

        FPJS.generateData().then(function(components) {
            fp.components = components;
            return FPJS.generateFingerprint(components);
        }).then(function(fingerprint) {
            fp.fingerprint = fingerprint;
            return Login.set($scope.credentials.username, $scope.credentials.password, {fingerprint:fingerprint});
        }).then(function (data) {
            $scope.pageData.success = true;


            if (bugsnagClient.user) {
                // not consistent since lost after page reload
                // bugsnagClient.user.name = $scope.credentials.username;
            }

            if (data.status === "otp") {
                //fingerprint changed
                bugsnagClient.notify({name: "Fingerprint", message:"New Fingerprint Request"}, {
                    severity: 'info',
                    metaData: {
                        fingerprinting: {
                            status: data.status,
                            fingerprint: fp.fingerprint,
                            components: fp.components,
                        }
                    },
                });

                $scope.$state.go('public.login.otp');
                return;
            } else if (data.status === "migrate") {
                $scope.$state.go('base.security-update', {}, {location: 'replace'});
            } else {
                $scope.validLogin();
            }

            $timeout(function () {
                $scope.hardReload = true;
            }, 45 * 1000);

        }).catch(function (response) {

            if (response instanceof Error) {
                throw response;
            } else if (response.status === 503) {
                return;
            } else {
                $scope.pageData.loginCount++;
                Session.set('login-count', $scope.pageData.loginCount);
                Session.set('login-date', moment());

                var message;

                $scope.pageData.sending = false;
                $scope.pageData.errorCount++;

                message = (response.data && response.data.message) ? response.data.message : "The username and password combo doesn't match – please try again.";
                if ($scope.pageData.errorCount === 3) {
                    message = "The username and password combo doesn't match – two attempts remaining.";
                } else if ($scope.pageData.errorCount === 4) {
                    message = "The username and password combo doesn't match – one attempt remaining.";
                } else if ($scope.pageData.errors > 4) {
                    message = "For your security, we lock logins after five unsuccessful attempts. Please reset your password using the link below or contact support@axosinvest.com for assistance.";
                }

                Message.set({
                    "type": "danger",
                    "text": message
                });
            }
        });
    };

    $scope.validLogin = function() {
        var target = Auth.getTarget();
        $scope.$state.go(target.path, target.params, {location: 'replace'});
        Track.send('Login', 'auth', {});

        Session.set('login-count', 0);
    };

    $scope.$watch('hardReload', function(hr) {
       //if state hasn't changed within a second after a successfull login, for a page reload
        if (hr) {
            $window.location.reload();
            // alert('test');
        }
    });


    $scope.openAxosBankModal = function() {
        var $modalScope = $scope.$new();
        $modalScope.mobile = $scope.isMobile();
        var modalInstance = $uibModal.open({
            scope: $modalScope,
            templateUrl: "axos-invest-new-home-modal.tpl.html",
            size: 'md',
            keyboard: false,
            backdrop: 'static',
            windowClass: ''
        });
    }

    $scope.isMobile = function() {
        if (isIOS()) {
            return "ios";
        } else if (isAndroid()) {
            return "android";
        }
        return false;

        function isIOS() {
            return /iPhone|iPad|iPod/i.test($window.navigator.userAgent) && !window.MSStream;
        }
        function isAndroid() {
            return /Android/i.test($window.navigator.userAgent);
        }
    }

    if (!$scope.wbBeta) {
        $scope.openAxosBankModal();
    }

}]);
